export default __webpack_public_path__ + "f51b15843706471d413a60260d6351c3.svg";